import { loadAuditCore, saveAuditCore, ensureAuditCoreSaved } from './auditCoreApi';

const SYNC_MAPPINGS = [
  { localKey: 'audit_kanban_data', auditCoreKey: 'audit-kanban', parseAsJson: true },
  { localKey: 'audit_projects_data', auditCoreKey: 'audit-projects', parseAsJson: true },
  { localKey: 'audit_plans_data', auditCoreKey: 'audit-plans', parseAsJson: true },
  { localKey: 'audit_plans_backup', auditCoreKey: 'audit-plans-backup', parseAsJson: true },
  { localKey: 'audit_portal_user_groups', auditCoreKey: 'audit-groups', parseAsJson: true },
  { localKey: 'ippf_auditors_data', auditCoreKey: 'ippf-auditors', parseAsJson: true },
  { localKey: 'ippf_audit_groups_data', auditCoreKey: 'ippf-audit-groups', parseAsJson: true },
  // 风险矩阵主数据统一走 /api/risks 保存，避免与 /api/audit-core/risk-matrix 权限口径冲突
  { localKey: 'riskMatrix_orgChart', auditCoreKey: 'org-chart', parseAsJson: true },
  { localKey: 'riskMatrix_decisionTodoIds', auditCoreKey: 'risk-matrix-decision-todo-ids', parseAsJson: true },
  { localKey: 'riskMatrix_snapshots', auditCoreKey: 'risk-matrix-snapshots', parseAsJson: true },
  { localKey: 'risk_event_custom_maps', auditCoreKey: 'risk-event-custom-maps', parseAsJson: true },
  { localKey: 'risk_event_extra_items', auditCoreKey: 'risk-event-extra-items', parseAsJson: true },
  { localKey: 'risk_event_item_scores', auditCoreKey: 'risk-event-item-scores', parseAsJson: true },
  { localKey: 'incompatibleDutiesData', auditCoreKey: 'incompatible-duties', parseAsJson: true },
  { localKey: 'broilerInternalControlData', auditCoreKey: 'broiler-internal-control', parseAsJson: true },
  { localKey: 'ic_eval_main', auditCoreKey: 'ic-eval-main', parseAsJson: true },
  { localKey: 'ic_eval_tests', auditCoreKey: 'ic-eval-tests', parseAsJson: true },
  { localKey: 'ic_eval_module_groups', auditCoreKey: 'ic-eval-module-groups', parseAsJson: true },
  { localKey: 'ic_eval_survey_records', auditCoreKey: 'ic-eval-survey-records', parseAsJson: true },
  { localKey: 'audit_findings', auditCoreKey: 'audit-findings', parseAsJson: true },
  { localKey: 'rectification_center_data', auditCoreKey: 'rectification-center', parseAsJson: true },
  { localKey: 'audit_portal_users_db', auditCoreKey: 'user-management', parseAsJson: true },
  { localKey: 'ai_api_config', auditCoreKey: 'ai-api-config', parseAsJson: true },
  { localKey: 'ai_api_configs', auditCoreKey: 'ai-api-configs', parseAsJson: true },
  { localKey: 'ai_default_provider', auditCoreKey: 'ai-default-provider', parseAsJson: false },
  { localKey: 'ai_enabled_features', auditCoreKey: 'ai-enabled-features', parseAsJson: true },
  { localKey: 'ai_usage_stats', auditCoreKey: 'ai-usage-stats', parseAsJson: true },
  { localKey: 'audit_settings', auditCoreKey: 'audit-settings', parseAsJson: true },
  { localKey: 'audit_permissions', auditCoreKey: 'audit-permissions', parseAsJson: true },
  { localKey: 'audit_notifications', auditCoreKey: 'audit-notifications', parseAsJson: true },
  { localKey: 'audit_backup_config', auditCoreKey: 'audit-backup-config', parseAsJson: true },
  { localKey: 'audit_backups', auditCoreKey: 'audit-backups', parseAsJson: true },
  { localKey: 'audit_logs', auditCoreKey: 'audit-logs', parseAsJson: true },
  { localKey: 'audit_project_templates', auditCoreKey: 'project-templates', parseAsJson: true },
  { localKey: 'project_templates_data', auditCoreKey: 'project-templates', parseAsJson: true },
  { localKey: 'audit_programs', auditCoreKey: 'audit-standard-programs', parseAsJson: true },
  { localKey: 'audit_programs_data', auditCoreKey: 'audit-standard-programs', parseAsJson: true },
  { localKey: 'audit_workpaper_templates', auditCoreKey: 'audit-workpaper-templates', parseAsJson: true },
  { localKey: 'workpaper_templates_data', auditCoreKey: 'audit-workpaper-templates', parseAsJson: true },
  { localKey: 'audit_regulation_library', auditCoreKey: 'knowledge-regulations', parseAsJson: true },
  { localKey: 'regulation_library_data', auditCoreKey: 'knowledge-regulations', parseAsJson: true },
  { localKey: 'audit_case_library', auditCoreKey: 'knowledge-cases', parseAsJson: true },
  { localKey: 'case_library_data', auditCoreKey: 'knowledge-cases', parseAsJson: true },
  { localKey: 'audit_knowledge_bases', auditCoreKey: 'audit-knowledge-bases', parseAsJson: true },
  { localKey: 'opinion_plan_groups', auditCoreKey: 'opinion-plan-groups', parseAsJson: true },
  { localKey: 'opinion_plans', auditCoreKey: 'opinion-plans', parseAsJson: true },
  { localKey: 'opinion_articles', auditCoreKey: 'opinion-articles', parseAsJson: true },
  { localKey: 'opinion_event_tasks', auditCoreKey: 'opinion-event-tasks', parseAsJson: true },
  { localKey: 'opinion_alerts', auditCoreKey: 'opinion-alerts', parseAsJson: true },
  { localKey: 'supervision_complaints', auditCoreKey: 'supervision-complaints', parseAsJson: true },
  { localKey: 'supervision_tips', auditCoreKey: 'supervision-tips', parseAsJson: true },
  { localKey: 'supervision_rectification', auditCoreKey: 'supervision-rectification', parseAsJson: true },
  { localKey: 'supervision_notices', auditCoreKey: 'supervision-notices', parseAsJson: true },
  { localKey: 'supervision_related_party', auditCoreKey: 'supervision-related-party', parseAsJson: true },
  { localKey: 'supervision_topics', auditCoreKey: 'supervision-topics', parseAsJson: true },
  { localKey: 'audit_risk_warning_rules', auditCoreKey: 'audit-risk-warning-rules', parseAsJson: true },
  { localKey: 'audit_risk_warnings', auditCoreKey: 'audit-risk-warnings', parseAsJson: true },
  { localKey: 'audit_anomaly_records', auditCoreKey: 'audit-anomaly-records', parseAsJson: true },
  { localKey: 'audit_templates', auditCoreKey: 'audit-templates', parseAsJson: true },
  { localKey: 'audit_task_templates', auditCoreKey: 'audit-task-templates', parseAsJson: true },
  { localKey: 'audit_tools_saved', auditCoreKey: 'audit-tools-saved', parseAsJson: true },
  { localKey: 'audit_report_api_config', auditCoreKey: 'audit-report-api-config', parseAsJson: true },
  { localKey: 'audit_custom_quick_nav', auditCoreKey: 'audit-custom-quick-nav', parseAsJson: true },
  { localKey: 'audit_project_library_favorites', auditCoreKey: 'audit-project-library-favorites', parseAsJson: true },
  { localKey: 'audit_project_library_recent', auditCoreKey: 'audit-project-library-recent', parseAsJson: true },
  { localKey: 'model_favorites', auditCoreKey: 'model-favorites', parseAsJson: true },
  { localKey: 'product_cost_data', auditCoreKey: 'product-cost-data', parseAsJson: true },
  { localKey: 'reportDashboardReports', auditCoreKey: 'report-dashboard-reports', parseAsJson: true },
  { localKey: 'reportDashboard_pendingSync', auditCoreKey: 'report-dashboard-pending-sync', parseAsJson: true },
  { localKey: 'pxcharts_tasks', auditCoreKey: 'pxcharts-tasks', parseAsJson: true },
  { localKey: 'pxcharts_tables_list', auditCoreKey: 'pxcharts-tables-list', parseAsJson: true },
  { localKey: 'poultry_budget_data', auditCoreKey: 'poultry-budget-data', parseAsJson: true },
  { localKey: 'poultry_chain_cost_v3', auditCoreKey: 'poultry-chain-cost-v3', parseAsJson: true },
  { localKey: 'broilerSupplyChainReports', auditCoreKey: 'broiler-supply-chain-reports', parseAsJson: true },
  { localKey: 'broilerSlaughterLineReports', auditCoreKey: 'broiler-slaughter-line-reports', parseAsJson: true },
  { localKey: 'engineering_audit_projects', auditCoreKey: 'engineering-audit-projects', parseAsJson: true },
  { localKey: 'it_audit_projects', auditCoreKey: 'it-audit-projects', parseAsJson: true },
  { localKey: 'engineering_audit_contracts', auditCoreKey: 'engineering-audit-contracts', parseAsJson: true },
  { localKey: 'engineering_capex_planning', auditCoreKey: 'engineering-capex-planning', parseAsJson: true },
  { localKey: 'engineering_capex_audit_checklist', auditCoreKey: 'engineering-capex-audit-checklist', parseAsJson: true },
  { localKey: 'engineering_capex_risk_warnings', auditCoreKey: 'engineering-capex-risk-warnings', parseAsJson: true },
  { localKey: 'eng_projects_column_settings_v1', auditCoreKey: 'engineering-projects-column-settings', parseAsJson: true },
  { localKey: 'strategic_maturity_scores', auditCoreKey: 'strategic-maturity-scores', parseAsJson: true },
  { localKey: 'strategic_maturity_targets', auditCoreKey: 'strategic-maturity-targets', parseAsJson: true },
  { localKey: 'strategic_maturity_module_scores', auditCoreKey: 'strategic-maturity-module-scores', parseAsJson: true },
  { localKey: 'strategic_maturity_module_descriptions', auditCoreKey: 'strategic-maturity-module-descriptions', parseAsJson: true },
  { localKey: 'strategic_maturity_root_cause', auditCoreKey: 'strategic-maturity-root-cause', parseAsJson: true },
  { localKey: 'strategic_maturity_custom_modules', auditCoreKey: 'strategic-maturity-custom-modules', parseAsJson: true },
  { localKey: 'strategic_roadmap_nodes', auditCoreKey: 'strategic-roadmap-nodes', parseAsJson: true },
  { localKey: 'strategic_roadmap_links', auditCoreKey: 'strategic-roadmap-links', parseAsJson: true },
  { localKey: 'hotspot_module_config', auditCoreKey: 'hotspot-module-config', parseAsJson: true },
  { localKey: 'hotspot_enabled_platforms', auditCoreKey: 'hotspot-enabled-platforms', parseAsJson: true },
  { localKey: 'hotspot_radar_data_v4', auditCoreKey: 'hotspot-radar-data-v4', parseAsJson: true },
  { localKey: 'web_scraper_schemes', auditCoreKey: 'web-scraper-schemes', parseAsJson: true },
  { localKey: 'web_scraper_history', auditCoreKey: 'web-scraper-history', parseAsJson: true },
  { localKey: 'multimodal_workflows', auditCoreKey: 'multimodal-workflows', parseAsJson: true },
  { localKey: 'multimodal_chat_v4', auditCoreKey: 'multimodal-chat-v4', parseAsJson: true },
  { localKey: 'multimodal_chat_history', auditCoreKey: 'multimodal-chat-history', parseAsJson: true },
  { localKey: 'custom_task_status_config', auditCoreKey: 'custom-task-status-config', parseAsJson: true },
  { localKey: 'custom_task_priority_config', auditCoreKey: 'custom-task-priority-config', parseAsJson: true },
  { localKey: 'header_button_config', auditCoreKey: 'header-button-config', parseAsJson: true },
  { localKey: 'futures_data_source', auditCoreKey: 'futures-data-source', parseAsJson: false },
  { localKey: 'tushare_token', auditCoreKey: 'tushare-token', parseAsJson: false },
  { localKey: 'costSavingAnalysisRecords', auditCoreKey: 'cost-saving-analysis-records', parseAsJson: true },
  { localKey: 'corn_verification_records', auditCoreKey: 'corn-verification-records', parseAsJson: true },
  { localKey: 'arrivalSavedRecords', auditCoreKey: 'arrival-saved-records', parseAsJson: true },
  { localKey: 'moisturePriceRecords', auditCoreKey: 'moisture-price-records', parseAsJson: true },
  { localKey: 'cornDecision_savedConfigs', auditCoreKey: 'corn-decision-saved-configs', parseAsJson: true },
  { localKey: 'priceComparisonRecords', auditCoreKey: 'price-comparison-records', parseAsJson: true },
  { localKey: 'brainstorm_risk_library', auditCoreKey: 'brainstorm-risk-library', parseAsJson: true },
  { localKey: 'zhuochuangPriceData', auditCoreKey: 'zhuochuang-price-data', parseAsJson: true },
  { localKey: 'mysteelPriceData', auditCoreKey: 'mysteel-price-data', parseAsJson: true },
  { localKey: 'materialArrivalData', auditCoreKey: 'material-arrival-data', parseAsJson: true },
  { localKey: 'corn_moisture_dist_data', auditCoreKey: 'corn-moisture-dist-data', parseAsJson: true },
  { localKey: '_device_seed', auditCoreKey: 'device-seed', parseAsJson: false },
  { localKey: 'ai_api_expire_date', auditCoreKey: 'ai-api-expire-date', parseAsJson: false },
  { localKey: 'ai_current_model', auditCoreKey: 'ai-current-model', parseAsJson: false },
  { localKey: 'ai_multi_model_stats', auditCoreKey: 'ai-multi-model-stats', parseAsJson: true },
  { localKey: 'ai_show_thinking', auditCoreKey: 'ai-show-thinking', parseAsJson: false },
  { localKey: 'audit-plans', auditCoreKey: 'audit-plans-legacy', parseAsJson: true },
  { localKey: 'auditDashboard_expenseRatioRecords', auditCoreKey: 'audit-dashboard-expense-ratio-records', parseAsJson: true },
  { localKey: 'audit_group_feature_config', auditCoreKey: 'audit-group-feature-config', parseAsJson: true },
  { localKey: 'audit_kanban_settings', auditCoreKey: 'audit-kanban-settings', parseAsJson: true },
  { localKey: 'audit_workflow_instances', auditCoreKey: 'audit-workflow-instances', parseAsJson: true },
  { localKey: 'carcass_value_model_data', auditCoreKey: 'carcass-value-model-data', parseAsJson: true },
  { localKey: 'commodityMonitor_futuresContracts', auditCoreKey: 'commodity-monitor-futures-contracts', parseAsJson: true },
  { localKey: 'cvp_analysis_data', auditCoreKey: 'cvp-analysis-data', parseAsJson: true },
  { localKey: 'feed_nutrition_model_data', auditCoreKey: 'feed-nutrition-model-data', parseAsJson: true },
  { localKey: 'ippf_assessments', auditCoreKey: 'ippf-assessments', parseAsJson: true },
  { localKey: 'opinion_api_configs', auditCoreKey: 'opinion-api-configs', parseAsJson: true },
  { localKey: 'pxcharts_columns', auditCoreKey: 'pxcharts-columns', parseAsJson: true },
  { localKey: 'report_dashboard_reports', auditCoreKey: 'report-dashboard-reports-legacy', parseAsJson: true },
  { localKey: 'roi_analysis_data', auditCoreKey: 'roi-analysis-data', parseAsJson: true },
  { localKey: 'sidebarCollapsed', auditCoreKey: 'sidebar-collapsed', parseAsJson: false },
  { localKey: 'sidebar_shortcuts', auditCoreKey: 'sidebar-shortcuts', parseAsJson: true },
  { localKey: 'sidebar_shortcuts_frozen', auditCoreKey: 'sidebar-shortcuts-frozen', parseAsJson: true },
  { localKey: 'tts_settings', auditCoreKey: 'tts-settings', parseAsJson: true },
  { localKey: 'weather_city', auditCoreKey: 'weather-city', parseAsJson: false },
  { localKey: 'zhaimen_last_sync', auditCoreKey: 'zhaimen-last-sync', parseAsJson: false },
  { localKey: 'zhaimen_synced_data', auditCoreKey: 'zhaimen-synced-data', parseAsJson: true },
];

const mappingByLocalKey = new Map(SYNC_MAPPINGS.map((x) => [x.localKey, x]));
const PREFIX_MAPPINGS = [
  { localPrefix: 'pxcharts_table_', auditCoreKey: 'pxcharts-table-datasets' },
  { localPrefix: 'ai_model_config_', auditCoreKey: 'ai-model-configs' },
  { localPrefix: 'ai_api_key_', auditCoreKey: 'ai-model-api-keys' },
  { localPrefix: 'heq_llm_', auditCoreKey: 'high-eq-llm-configs' },
  { localPrefix: 'cherry_', auditCoreKey: 'cherry-configs' },
  { localPrefix: 'cornDecision_', auditCoreKey: 'corn-decision-configs' },
  { localPrefix: 'rf_', auditCoreKey: 'rolling-forecast-configs' },
  { localPrefix: 'it_audit_', auditCoreKey: 'it-audit-module-data' },
  { localPrefix: 'engineering_audit_', auditCoreKey: 'engineering-audit-module-data' },
  { localPrefix: 'minimax_', auditCoreKey: 'minimax-configs' },
  { localPrefix: 'deepseek_ocr_', auditCoreKey: 'deepseek-ocr-configs' },
  { localPrefix: 'doubao_tts_', auditCoreKey: 'doubao-tts-configs' },
];
const AUTH_EXCLUDED_KEYS = new Set([
  'token',
  'audit_portal_user',
  'current_user',
  'userInfo',
]);
const SENSITIVE_LOCAL_KEYS = new Set([
  '_device_seed',
  'ai_api_config',
  'ai_api_configs',
  'deepseek_ocr_api_key',
  'doubao_tts_api_key',
  'doubao_tts_app_id',
  'minimax_api_key',
  'tushare_token',
]);
const SENSITIVE_LOCAL_PREFIXES = [
  'ai_api_key_',
  'ai_model_config_',
  'cherry_',
  'deepseek_ocr_',
  'doubao_tts_',
  'heq_llm_',
  'minimax_',
];
const SNAPSHOT_AUDIT_CORE_KEY = 'module-localstorage-snapshot';
const SERVER_AUTHORITY_LOCAL_KEYS = new Set([
  'audit_kanban_data',
  'audit_plans_data',
  'audit_findings',
  'rectification_center_data',
]);
const RECOVERY_SUFFIX = '__server_conflict_recovery';

/** 全量快照不带上这些前缀（如 Cherry 对话全量，体积可达数十 MB，易触发 Nginx 默认 1m 的 413） */
const SNAPSHOT_EXCLUDED_PREFIXES = ['cherry_'];

/** 单条 localStorage 值超过该长度则不进入快照，避免整包 PUT 过大 */
const SNAPSHOT_MAX_VALUE_CHARS = 800000;
const BOOTSTRAP_LOCAL_KEYS = [
  'audit_kanban_data',
  'audit_plans_data',
  'riskMatrixData',
  'broilerInternalControlData',
  'audit_portal_users_db',
  'audit_portal_user_groups',
  'audit_permissions',  // 权限管理配置，需从服务器加载以使所有用户/设备一致
];
const debounceTimers = new Map();
const lastRawSnapshot = new Map();
const prefixDebounceTimers = new Map();
let snapshotDebounceTimer = null;
let snapshotRawCache = '';

let started = false;
let suppressSync = false;
let originalSetItem = null;
let originalRemoveItem = null;
let bootstrapHydrated = false;

function safeParseJson(raw) {
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

function hasAuthToken() {
  try {
    return !!localStorage.getItem('token');
  } catch (_) {
    return false;
  }
}

function isSensitiveLocalKey(localKey) {
  if (!localKey) return false;
  if (SENSITIVE_LOCAL_KEYS.has(localKey)) return true;
  return SENSITIVE_LOCAL_PREFIXES.some((prefix) => localKey.startsWith(prefix));
}

function getTimestampFromData(data) {
  if (!data || typeof data !== 'object') return 0;
  const rootTs = Date.parse(data.updatedAt || data.lastUpdatedAt || '') || 0;
  if (!Array.isArray(data.projects)) return rootTs;
  const projectTs = Math.max(
    0,
    ...data.projects.map((p) => Date.parse(p?.updatedAt || p?.createdAt || '') || 0)
  );
  return Math.max(rootTs, projectTs);
}

function preserveServerConflictRecovery(localKey, localData, serverData) {
  if (!originalSetItem) return;
  const raw = JSON.stringify({
    capturedAt: new Date().toISOString(),
    localData,
    serverData,
  });
  originalSetItem.call(localStorage, `${localKey}${RECOVERY_SUFFIX}`, raw);
}

async function syncLocalKey(localKey, rawValue) {
  if (isSensitiveLocalKey(localKey)) return;
  const mapping = mappingByLocalKey.get(localKey);
  if (!mapping) return;

  let payload = rawValue;
  if (mapping.parseAsJson) {
    const parsed = safeParseJson(rawValue);
    if (parsed == null && rawValue != null && rawValue !== '') return;
    payload = parsed;
  }

  await ensureAuditCoreSaved(mapping.auditCoreKey, payload, `统一同步:${localKey}`);
}

function collectPrefixSnapshot(localPrefix) {
  const entries = {};
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (!key || !key.startsWith(localPrefix)) continue;
    if (isSensitiveLocalKey(key)) continue;
    entries[key] = localStorage.getItem(key);
  }
  return {
    updatedAt: new Date().toISOString(),
    entries,
  };
}

function getPrefixMapping(localKey) {
  if (isSensitiveLocalKey(localKey)) return null;
  return PREFIX_MAPPINGS.find((item) => localKey.startsWith(item.localPrefix)) || null;
}

async function syncPrefixMapping(localPrefix) {
  if (isSensitiveLocalKey(localPrefix)) return;
  const mapping = PREFIX_MAPPINGS.find((item) => item.localPrefix === localPrefix);
  if (!mapping) return;
  const payload = collectPrefixSnapshot(localPrefix);
  await ensureAuditCoreSaved(mapping.auditCoreKey, payload, `统一同步前缀:${localPrefix}`);
}

function schedulePrefixSync(localKey) {
  const mapping = getPrefixMapping(localKey);
  if (!mapping || suppressSync || !hasAuthToken()) return;
  const old = prefixDebounceTimers.get(mapping.localPrefix);
  if (old) clearTimeout(old);
  const timer = setTimeout(() => {
    prefixDebounceTimers.delete(mapping.localPrefix);
    syncPrefixMapping(mapping.localPrefix).catch((e) => {
      console.warn(`[统一同步] ${mapping.localPrefix} 前缀保存失败:`, e?.message || e);
    });
  }, 700);
  prefixDebounceTimers.set(mapping.localPrefix, timer);
}

function shouldTrackInSnapshot(localKey) {
  if (!localKey) return false;
  if (localKey.endsWith(RECOVERY_SUFFIX)) return false;
  if (AUTH_EXCLUDED_KEYS.has(localKey)) return false;
  if (isSensitiveLocalKey(localKey)) return false;
  return true;
}

function shouldIncludeInBusinessSnapshotEntry(key, value) {
  if (SNAPSHOT_EXCLUDED_PREFIXES.some((p) => key.startsWith(p))) return false;
  const s = value == null ? '' : String(value);
  if (s.length > SNAPSHOT_MAX_VALUE_CHARS) return false;
  return true;
}

/** 写入服务端快照前过滤，避免把历史大包或排除键再次 PUT */
function filterSnapshotEntriesForUpload(entries) {
  const out = {};
  for (const [k, v] of Object.entries(entries || {})) {
    if (!shouldTrackInSnapshot(k)) continue;
    if (!shouldIncludeInBusinessSnapshotEntry(k, v)) continue;
    out[k] = String(v ?? '');
  }
  return out;
}

function collectBusinessSnapshot() {
  const entries = {};
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (!shouldTrackInSnapshot(key)) continue;
    const value = localStorage.getItem(key);
    if (!shouldIncludeInBusinessSnapshotEntry(key, value)) continue;
    entries[key] = value;
  }
  return {
    updatedAt: new Date().toISOString(),
    entries,
  };
}

async function syncBusinessSnapshot() {
  const payload = collectBusinessSnapshot();
  const raw = JSON.stringify(payload);
  if (raw === snapshotRawCache) return;
  snapshotRawCache = raw;
  await ensureAuditCoreSaved(SNAPSHOT_AUDIT_CORE_KEY, payload, '统一同步快照');
}

function scheduleBusinessSnapshotSync() {
  if (suppressSync || !hasAuthToken()) return;
  if (snapshotDebounceTimer) clearTimeout(snapshotDebounceTimer);
  snapshotDebounceTimer = setTimeout(() => {
    snapshotDebounceTimer = null;
    syncBusinessSnapshot().catch((e) => {
      console.warn('[统一同步] 全量快照保存失败:', e?.message || e);
    });
  }, 900);
}

function scheduleSync(localKey, rawValue) {
  if (isSensitiveLocalKey(localKey)) return;
  if (!mappingByLocalKey.has(localKey)) return;
  if (suppressSync || !hasAuthToken()) return;

  const prev = lastRawSnapshot.get(localKey);
  if (prev === rawValue) return;
  lastRawSnapshot.set(localKey, rawValue);

  const oldTimer = debounceTimers.get(localKey);
  if (oldTimer) clearTimeout(oldTimer);
  const timer = setTimeout(() => {
    debounceTimers.delete(localKey);
    syncLocalKey(localKey, rawValue).catch((e) => {
      console.warn(`[统一同步] ${localKey} 保存到服务器失败:`, e?.message || e);
    });
  }, 600);
  debounceTimers.set(localKey, timer);
}

function setLocalValue(localKey, data, parseAsJson) {
  const nextRaw = parseAsJson ? JSON.stringify(data) : String(data ?? '');
  suppressSync = true;
  try {
    originalSetItem.call(localStorage, localKey, nextRaw);
    lastRawSnapshot.set(localKey, nextRaw);
    if (localKey === 'audit_permissions') {
      window.dispatchEvent(new CustomEvent('audit-permissions-updated', { detail: data }));
    }
  } finally {
    suppressSync = false;
  }
}

function setLocalRawValue(localKey, rawValue) {
  suppressSync = true;
  try {
    originalSetItem.call(localStorage, localKey, String(rawValue ?? ''));
    lastRawSnapshot.set(localKey, String(rawValue ?? ''));
    if (localKey === 'audit_permissions') {
      window.dispatchEvent(new CustomEvent('audit-permissions-updated'));
    }
  } finally {
    suppressSync = false;
  }
}

function hasAnyBusinessDataLocally() {
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (shouldTrackInSnapshot(key)) return true;
  }
  return false;
}

async function hydratePrefixMappings() {
  for (const mapping of PREFIX_MAPPINGS) {
    if (isSensitiveLocalKey(mapping.localPrefix)) continue;
    const localPayload = collectPrefixSnapshot(mapping.localPrefix);
    const localEntries = localPayload.entries || {};
    const localHasAny = Object.keys(localEntries).length > 0;
    const serverPayload = await loadAuditCore(mapping.auditCoreKey);
    const serverEntries = serverPayload?.entries && typeof serverPayload.entries === 'object'
      ? serverPayload.entries
      : {};
    const serverHasAny = Object.keys(serverEntries).length > 0;

    if (!localHasAny && serverHasAny) {
      for (const [key, value] of Object.entries(serverEntries)) {
        setLocalRawValue(key, value);
      }
      continue;
    }

    if (localHasAny || serverHasAny) {
      const merged = { ...serverEntries, ...localEntries };
      for (const [key, value] of Object.entries(merged)) {
        if (localStorage.getItem(key) !== String(value ?? '')) {
          setLocalRawValue(key, value);
        }
      }
      await ensureAuditCoreSaved(mapping.auditCoreKey, {
        updatedAt: new Date().toISOString(),
        entries: merged,
      }, `统一同步前缀回填:${mapping.localPrefix}`);
    }
  }
}

async function hydrateBusinessSnapshot() {
  const localHasAny = hasAnyBusinessDataLocally();
  const serverSnapshot = await loadAuditCore(SNAPSHOT_AUDIT_CORE_KEY);
  const serverEntries = serverSnapshot?.entries && typeof serverSnapshot.entries === 'object'
    ? serverSnapshot.entries
    : {};
  const serverHasAny = Object.keys(serverEntries).length > 0;

  if (!localHasAny && serverHasAny) {
    for (const [key, value] of Object.entries(serverEntries)) {
      if (!shouldTrackInSnapshot(key)) continue;
      setLocalRawValue(key, value);
    }
    return;
  }

  if (!localHasAny && !serverHasAny) return;

  const localSnapshot = collectBusinessSnapshot();
  const localEntries = localSnapshot.entries || {};
  const merged = { ...serverEntries, ...localEntries };
  for (const [key, value] of Object.entries(merged)) {
    if (!shouldTrackInSnapshot(key)) continue;
    if (localStorage.getItem(key) !== String(value ?? '')) {
      setLocalRawValue(key, value);
    }
  }
  await ensureAuditCoreSaved(SNAPSHOT_AUDIT_CORE_KEY, {
    updatedAt: new Date().toISOString(),
    entries: filterSnapshotEntriesForUpload(merged),
  }, '统一同步快照回填');
}

async function hydrateFromServerOrPushLocal() {
  for (const localKey of BOOTSTRAP_LOCAL_KEYS) {
    if (isSensitiveLocalKey(localKey)) continue;
    const mapping = mappingByLocalKey.get(localKey);
    if (!mapping) continue;
    const localRaw = localStorage.getItem(mapping.localKey);
    const localData = mapping.parseAsJson ? safeParseJson(localRaw || '') : localRaw;
    const serverData = await loadAuditCore(mapping.auditCoreKey);

    if (SERVER_AUTHORITY_LOCAL_KEYS.has(localKey)) {
      if (serverData == null) continue;
      if (localRaw != null && JSON.stringify(localData) !== JSON.stringify(serverData)) {
        preserveServerConflictRecovery(localKey, localData, serverData);
      }
      setLocalValue(mapping.localKey, serverData, mapping.parseAsJson);
      continue;
    }

    // 服务器无数据：将本地推到服务器，保证“都保存在服务器”
    if (serverData == null) {
      if (localRaw != null) {
        scheduleSync(mapping.localKey, localRaw);
      }
      continue;
    }

    // 本地无数据：用服务器回填本地
    if (localRaw == null) {
      setLocalValue(mapping.localKey, serverData, mapping.parseAsJson);
      continue;
    }

    // 两边都有数据：按时间戳取新；对 audit_permissions 特殊处理：本地为空配置时优先用服务器
    const localTs = getTimestampFromData(localData);
    const serverTs = getTimestampFromData(serverData);
    if (serverTs > localTs && serverTs > 0) {
      setLocalValue(mapping.localKey, serverData, mapping.parseAsJson);
    } else if (mapping.auditCoreKey === 'audit-permissions') {
      const localEmpty = !localData || (typeof localData === 'object' && Object.keys(localData.roles || {}).length === 0 && Object.keys(localData.users || {}).length === 0 && Object.keys(localData.groups || {}).length === 0 && Object.keys(localData.modules || {}).length === 0);
      const serverHasData = serverData && typeof serverData === 'object' && (Object.keys(serverData.roles || {}).length > 0 || Object.keys(serverData.users || {}).length > 0 || Object.keys(serverData.groups || {}).length > 0 || Object.keys(serverData.modules || {}).length > 0);
      if (localEmpty && serverHasData) {
        setLocalValue(mapping.localKey, serverData, mapping.parseAsJson);
      } else if (localRaw != null) {
        scheduleSync(mapping.localKey, localRaw);
      }
    } else if (localRaw != null) {
      scheduleSync(mapping.localKey, localRaw);
    }
  }
  await hydrateBusinessSnapshot();
}

function ensureBootstrapHydrated() {
  if (bootstrapHydrated || !hasAuthToken()) return;
  bootstrapHydrated = true;
  hydrateFromServerOrPushLocal().catch((e) => {
    bootstrapHydrated = false;
    console.warn('[统一同步] 启动初始同步失败:', e?.message || e);
  });
}

export function startUnifiedModuleDataSync() {
  if (started || typeof window === 'undefined' || !window.localStorage) return;
  started = true;

  originalSetItem = localStorage.setItem;
  originalRemoveItem = localStorage.removeItem;
  localStorage.setItem = function patchedSetItem(key, value) {
    originalSetItem.call(localStorage, key, value);
    if (key === 'audit_permissions') {
      window.dispatchEvent(new CustomEvent('audit-permissions-updated'));
    }
    if (key === 'token') {
      ensureBootstrapHydrated();
      return;
    }
    scheduleSync(key, value);
    schedulePrefixSync(key);
    if (shouldTrackInSnapshot(key)) {
      scheduleBusinessSnapshotSync();
    }
  };
  localStorage.removeItem = function patchedRemoveItem(key) {
    originalRemoveItem.call(localStorage, key);
    lastRawSnapshot.delete(key);
    const mapping = mappingByLocalKey.get(key);
    if (mapping && !isSensitiveLocalKey(key)) {
      const oldTimer = debounceTimers.get(key);
      if (oldTimer) clearTimeout(oldTimer);
      const timer = setTimeout(() => {
        debounceTimers.delete(key);
        if (!hasAuthToken()) return;
        ensureAuditCoreSaved(mapping.auditCoreKey, null, `统一同步删除:${key}`).catch((e) => {
          console.warn(`[统一同步] ${key} 删除后同步失败:`, e?.message || e);
        });
      }, 400);
      debounceTimers.set(key, timer);
    }
    schedulePrefixSync(key);
    if (shouldTrackInSnapshot(key)) {
      scheduleBusinessSnapshotSync();
    }
  };

  ensureBootstrapHydrated();
}
